import { changeImageSrc, getBase64ImageByUrl } from '~src/utils';
import { triggerStateChangedRequest, b64toBlob } from '~core';
import {
  handleTabAttachments,
  displaySidebarAttachments,
  fetchEditorAttachments,
} from '~src/sidebarLegacy';
import { trackEvent } from '~src/tracking';
import { getState } from '~src/state';
import {
  startAiLoader,
  stopAiLoader,
  showAiSuccessMessage,
} from '~core/aiLoader';
import { handleTabImagesAI } from '~src/sidebar/index';

export async function applySelectedBlurBg(
  removebgRawImage,
  url,
  startTime,
  blurLevel
) {
  let selection = window.canvas.getActiveObject();
  if (selection.type === 'MagicFrame') {
    selection = selection.editingImg;
  }

  // Start a simple loader for the saving phase
  startAiLoader(
    [
      { icon: '💾', text: 'Salvando la foto con sfondo sfocato...' },
      { icon: '✅', text: 'Applicando al progetto...' },
    ],
    '💾 Salvataggio in corso'
  );

  try {
    const imageBase64 = await getBase64ImageByUrl(url);
    const blob = b64toBlob(imageBase64, 'image/jpeg');
    const attachmentsUploader = getState('uploader.allegati');

    attachmentsUploader.onComplete = attachmentsUploader.addFile({
      type: blob.type,
      data: blob,
      meta: {
        customAttachmentProps: {
          blurBgRawImage: url,
          isBlurBg: true,
          removebgRawImage,
        },
      },
    });

    const responseUpload = await attachmentsUploader.upload();
    attachmentsUploader.cancelAll();

    // Get the uploaded image URL
    const imageUrl = `${process.env.EDGE_RESIZER}${
      new URL(responseUpload.successful[0].uploadURL).pathname
    }`;

    // Apply to object
    let magicFrame = selection._magicFrame;
    if (selection.type === 'MagicFrame') {
      magicFrame = selection;
    }
    if (magicFrame) {
      await magicFrame.updatePerson(imageUrl);
      magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
      magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
      const giottoProps = magicFrame.get('giotto') ?? {};
      giottoProps.isBlurBg = true;
      magicFrame.set('giotto', giottoProps);
    } else {
      const image = selection;
      await changeImageSrc(image, imageUrl);
      const giottoProps = image.get('giotto') ?? {};
      giottoProps.isBlurBg = true;
      image.set('giotto', giottoProps);
    }

    window.canvas.renderAll();
    triggerStateChangedRequest();

    // Refresh attachments sidebar
    const { attachments } = await fetchEditorAttachments(true);
    window.editorConfig.sidebarAttachments = attachments;
    displaySidebarAttachments();
    handleTabAttachments();
    handleTabImagesAI();

    stopAiLoader();

    // Show success message
    showAiSuccessMessage(
      'Sfondo Sfocato',
      'Lo sfondo è stato sfocato con successo!'
    );

    trackEvent('AI BlurBG', {
      success: true,
      time_taken: parseInt(performance.now() - startTime, 10),
      blur_level: blurLevel,
    });
  } catch (error) {
    console.error('Error applying blurred background:', error);
    trackEvent('AI BlurBG', {
      success: false,
      error: error.message,
      time_taken: parseInt(performance.now() - startTime, 10),
      blur_level: blurLevel,
    });

    stopAiLoader();

    showAiSuccessMessage(
      'Errore',
      "Si è verificato un errore durante l'applicazione dello sfondo sfocato."
    );
  }
}
